import * as server from '../entries/pages/(app)/_layout.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/_layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/(app)/+layout.server.ts";
export const imports = ["_app/immutable/nodes/2.GazOY3E0.js","_app/immutable/chunks/disclose-version.bv6as8gS.js","_app/immutable/chunks/runtime.BQe1SyjF.js","_app/immutable/chunks/legacy.BsjUubzt.js","_app/immutable/chunks/slot.Cyf94Sph.js"];
export const stylesheets = [];
export const fonts = [];
